module.exports = __webpack_public_path__ + "assets/img/W.b557adac.png";